import { ENVS } from '../../../lib/env'

export const FEATURE_ENABLE_CONTROL_ON_DISCOUNT = 'enable_control_on_discount'
export const FEATURE_ENABLE_REGISTER_ACCESS_CONTROL =
  'enable_register_access_control'
export const REACT_CONFIRMATION_PANEL = 'react_confirmation_panel'
export const FEATURE_DEPRECATE_VD_ACTIVE_USER = 'deprecate_vd_active_user'
export const FEATURE_ROUND_TO_2DP_BEFORE_SENDING = 'round_to_2dp_before_sending'
export const CASH_COUNTING_FEATURE = 'LRX-17655-cash-counting'
export const FEATURE_ENABLE_INVOICING_PAYMENT_REQUESTS =
  'invoicing_payment_requests'
export const FEATURE_ENABLE_INVOICING_NON_FULFILLMENT_PAYMENT_REQUESTS =
  'invoicing_non_fulfillment_payment_requests'
export const FEATURE_ENABLE_INVOICING_QUOTE_PAYMENT_REQUESTS =
  'invoicing_quote_payment_requests'
export const FEATURE_ENABLE_INVOICING_PAYMENT_REQUEST_QUOTE_DELIVERY =
  'invoicing_payment_request_quote_delivery'
export const FEATURE_ENABLE_INVOICING_PAYMENT_REQUEST_AU_COMPLIANCE =
  'invoicing_payment_request_au_compliance'
export const FEATURE_ENABLE_INVOICING_QUOTE_SERVICE = 'invoicing_quote_service'
export const LRX_32023_MARK_ALL_ITEMS_FULFILLED =
  'LRX-32023_mark_all_items_fulfilled'
export const FEATURE_SALE_ADDRESS_MODAL_REFACTOR =
  'LRX-32392-sale-address-modal-refactor'
export const FEATURE_ENABLE_LRX_33701_STATE_VALIDATION =
  'LRX-33701_state_validation'
export const FEATURE_NEW_TAX_EXEMPTION_ENABLED = 'new_tax_exemption_enabled'
export const FEATURE_BARCODE_FROM_SALE_ID = 'LRX-33927-barcode_from_sale_id'
export const FEATURE_FULFILLMENT_TAKE_NOW_ITEM_PAYMENT_ENFORCEMENT =
  'fulfillment_take_now_item_payment_enforcement'
export const FEATURE_ALLOW_EDIT_UNFULFILLED_SALES =
  'allow_edit_unfulfilled_sales'
export const FEATURE_USE_2026_04_INVENTORY_API =
  'if_isp1_use_2026_04_inventory_api'
export const FEATURE_BARCODE_SCAN_ERROR_FIX = 'LRX_26016_barcode_scan_error_fix'
export const FEATURE_SSBO_ONBOARDING_COHORT = 'ssbo_onboarding_cohort'
export const FEATURE_SSBO_GUIDED_TOUR = 'ssbo_guided_tour'
export const FEATURE_ON_ACCOUNT_PAYMENT_TYPE = 'on_account_payment_type'
export const FEATURE_ON_ACCOUNT_PAY_VIA_REGISTER = 'on_account_pay_via_register'
export const FEATURE_SURCHARGE_TRANSLATION = 'surcharge_translation'
export const FEATURE_SHOW_SPECIAL_ORDERS_IN_INVENTORY =
  'if_isp1_show_quantity_to_procure'
export const LRX_32242_FEATURE_FLAG_FIX_DUPLICATE_API_CALL_ON_SAVED_SALES =
  'LRX_32242_feature_flag_fix_duplicate_api_call_on_saved_sales'
export const FEATURE_COMPLETE_PICKUP_AFTER_PAYMENT =
  'complete_pickup_after_payment'
export const FEATURE_REGISTER_BASEPRICE_AS_BESTPRICE =
  'register_baseprice_as_bestprice'
export const FEATURE_DISABLE_PAYMENT_BUTTONS_DURING_SALE_RECALCULATION =
  'LRX-33387_disable_payment_buttons_during_sale_recalculation'
export const LRX_39416_STALE_OFFLINE_SALE_REMEDIATION =
  'LRX-39416_stale-offline-sale-remediation'
export const FEATURE_VALIDATE_RETURN_QUANTITIES =
  'LRX_37470_validate_return_quantities'
export const FEATURE_XMEN2565_RECEIPT_WEB_PRESENCE =
  'XMEN2565_receipt_web_presence'
export const FEATURE_FAILFAST_BULK_SOLD_BY = 'Failfast-bulk-sold-by'
export const FEATURE_CROSS_LOCATION_FULFILMENT =
  'LRX-37996_selling_outlet_pay_clf'
export const FEATURE_LSPAY_CNP_PAYMENTS = 'lspay_cnp_payments'
export const FEATURE_LSPAY_CP_CNP_SPLIT_ENTRY = 'lspay_cp_cnp_split_entry'
export const FEATURE_UC_IN_WEBREGISTER_LINE_ITEM = 'uc_in_webregister_line_item'
export const FEATURE_UC_IN_WEBREGISTER_LOCK_ICON = 'uc_in_webregister_lock_icon'
export const LRX_41202_UC_IN_MARK_ALL_ITEM_FULFILLMENT =
  'LRX-41202_uc_in_mark_all_item_fulfillment'
export const FEATURE_UC_IN_WEBREGISTER_POPOVER = 'LRX-41200_uc_in_popover'
export const FEATURE_LSPAY_CASH_DISCOUNTING = 'lspay_cash_discounting'
export const LRX_28094_COLLAPSIBLE_CASH_COUNTING =
  'LRX_28094_collapsible_cash_counting'
export const LRX_39407_CHEQUE_REFERENCE_WRITE =
  'LRX-39407_cheque_reference_write'
export const LRX_39407_CHEQUE_REFERENCE_READ = 'LRX-39407_cheque_reference_read'
export const FEATURE_STANDALONE_CUSTOMER_FACING_DISPLAY_ENABLED =
  'standalone_customer_facing_display_enabled'
export const FEATURE_LSPAY_ABLY_AUTHCALLBACK_ENABLED =
  'lspay_ably_authcallback_enabled'
export const LRX_40761_ENABLE_QUANTITY_RECOGNIZED_WRITE_ON_TAKE_NOW =
  'LRX-40761_enable_quantity_recognized_write_on_take_now'
export const LRX_40761_ENABLE_QUANTITY_RECOGNIZED_WRITE_ON_FULFILLMENT =
  'LRX-40761_enable_quantity_recognized_write_on_fulfillment'
export const FEATURE_LRX_38368_MIGRATE_LEGACY_VERSION_REGISTER_SALES_WEBREGISTER =
  'LRX_38368_migrate_legacy_version_register_sales_webregister'

/**
 * Constants related to the feature flags in use within web register.
 *
 * This is a map of feature name to default value (per environment).
 *
 * Only specify features that are currently in use.
 * Always specify a sensible default value for the production environment.
 * Specify a sensible override for test/development environments if applicable.
 * Clean up features from here when they are no longer needed.
 *
 * @module webregister.constants.WR_FEATURES
 */
export const WR_FEATURES = {
  // Declare the default fallback value of each feature for production environments here
  [ENVS.PRODUCTION]: {
    // Feature flags based on retailer subscription plan
    gift_receipts: false,
    [FEATURE_ROUND_TO_2DP_BEFORE_SENDING]: false,
    promotions: false,
    promotions_advanced: false,
    customer_groups: true,
    // Selective features: These features cannot be rolled out 100% but can
    // only be enabled per retailer
    cash_discounting: false,
    // If you don't specify your feature flag here, it wont be requested in production and so will always be false
    cardholder_data_validation_webregister: false,
    direct_econduit: false,
    parked_sales_from_read_api: false,
    payment_type_controls: false,
    terminal_tipping: false,
    lspay_customer_facing_display_enabled: false,
    [FEATURE_STANDALONE_CUSTOMER_FACING_DISPLAY_ENABLED]: false,
    [FEATURE_LSPAY_ABLY_AUTHCALLBACK_ENABLED]: false,
    [FEATURE_LSPAY_CNP_PAYMENTS]: true,
    lspay_international_unreferenced_refunds: false,
    lspay_payment_links: false,
    lspay_pay_with_server_driven: false,
    lspay_refund_with_server_driven: false,
    lspay_referenced_refund_with_server_driven: false,
    lspay_pay_with_quick_pay_experiment: false,
    lspay_server_driven_override: false,
    lspay_surcharge: false,
    lspay_cash_discounting: false,
    lspay_surcharge_xero_onaccount: false,
    lspay_surcharge_qbo_onaccount: false,
    lspay_terminal_status_enabled: false,
    lspay_terminal_status_connection_logging_enabled: false,
    lspay_tipping_on_pre_tax_amount: false,
    raise_lspay_button_on_payment_screen_experiment: false,
    lspay_unreferenced_refund: false,
    lspay_simulated_reader: false,
    lspay_eseries_refunds_on_xseries: false,
    ideal_lspay_ecom_refunds: false,
    swiper_sandbox_lspay: false,
    enable_on_account_limit_enforcement: false,
    sales_person_attribution: false,
    fulfill_from_another_outlet: false,
    has_qbo: false,
    pufs_ignore_accounting_integrations: false,
    react_workflows: false,
    custom_fields_on_receipt: false,
    payment_integration_origin_validation: false,
    create_new_sale_after_validating: false,
    validate_new_sale: false,
    use_create_sale_endpoint: false,
    [LRX_39416_STALE_OFFLINE_SALE_REMEDIATION]: false,
    limit_product_images_in_webregister: false,
    register_closure_reminder_A: false,
    register_closure_reminder_B: false,
    register_closure_reminder_lspay: false,
    auxiliary_lspay_active_pli: false,
    enable_service_orders: false,
    register_online_only_customers_webregister: false,
    register_remove_local_customer_data_webregister: false,
    swiper_check_payment_type_available_jit: false,
    webregister_react_select_register: false,
    [FEATURE_ENABLE_CONTROL_ON_DISCOUNT]: false,
    increase_variant_limit: false,
    [FEATURE_ENABLE_REGISTER_ACCESS_CONTROL]: false,
    // Disables Transifex translations from being fetched
    disable_translation: false,
    new_user_switching_in_app: false,
    enable_permission_park_sale_check: false,
    omni_gift_cards: false,
    omni_gift_cards_allow_short_codes: false,
    [FEATURE_DEPRECATE_VD_ACTIVE_USER]: false,
    [REACT_CONFIRMATION_PANEL]: true,
    react_gift_card_modals: false,
    [CASH_COUNTING_FEATURE]: false,
    track_offline_sale_metadata: false,
    enable_customer_saved_cards: false,
    lspay_terminal_save_cards: false,
    lspay_show_repeat_card_detection: false,
    [FEATURE_ENABLE_INVOICING_PAYMENT_REQUESTS]: false,
    [FEATURE_ENABLE_INVOICING_NON_FULFILLMENT_PAYMENT_REQUESTS]: false,
    [FEATURE_ENABLE_INVOICING_QUOTE_PAYMENT_REQUESTS]: false,
    [FEATURE_ENABLE_INVOICING_PAYMENT_REQUEST_QUOTE_DELIVERY]: false,
    [FEATURE_ENABLE_INVOICING_PAYMENT_REQUEST_AU_COMPLIANCE]: false,
    [FEATURE_ENABLE_INVOICING_QUOTE_SERVICE]: false,
    [LRX_32023_MARK_ALL_ITEMS_FULFILLED]: false,
    [FEATURE_ENABLE_LRX_33701_STATE_VALIDATION]: false,
    inventory_special_orders: false,
    [FEATURE_SHOW_SPECIAL_ORDERS_IN_INVENTORY]: false,
    [FEATURE_SALE_ADDRESS_MODAL_REFACTOR]: false,
    [FEATURE_NEW_TAX_EXEMPTION_ENABLED]: false,
    [FEATURE_BARCODE_FROM_SALE_ID]: false,
    [FEATURE_FULFILLMENT_TAKE_NOW_ITEM_PAYMENT_ENFORCEMENT]: true,
    [FEATURE_ALLOW_EDIT_UNFULFILLED_SALES]: false,
    [FEATURE_USE_2026_04_INVENTORY_API]: false,
    [FEATURE_BARCODE_SCAN_ERROR_FIX]: false,
    [FEATURE_SSBO_ONBOARDING_COHORT]: false,
    [FEATURE_SSBO_GUIDED_TOUR]: false,
    [FEATURE_ON_ACCOUNT_PAYMENT_TYPE]: false,
    [FEATURE_ON_ACCOUNT_PAY_VIA_REGISTER]: false,
    [FEATURE_SURCHARGE_TRANSLATION]: false,
    [LRX_32242_FEATURE_FLAG_FIX_DUPLICATE_API_CALL_ON_SAVED_SALES]: false,
    [FEATURE_COMPLETE_PICKUP_AFTER_PAYMENT]: false,
    [FEATURE_REGISTER_BASEPRICE_AS_BESTPRICE]: false,
    [FEATURE_DISABLE_PAYMENT_BUTTONS_DURING_SALE_RECALCULATION]: false,
    [FEATURE_VALIDATE_RETURN_QUANTITIES]: false,
    [FEATURE_XMEN2565_RECEIPT_WEB_PRESENCE]: false,
    [FEATURE_FAILFAST_BULK_SOLD_BY]: false,
    [FEATURE_CROSS_LOCATION_FULFILMENT]: false,
    [FEATURE_LSPAY_CP_CNP_SPLIT_ENTRY]: false,
    [FEATURE_UC_IN_WEBREGISTER_LINE_ITEM]: false,
    [FEATURE_UC_IN_WEBREGISTER_LOCK_ICON]: false,
    [LRX_41202_UC_IN_MARK_ALL_ITEM_FULFILLMENT]: false,
    [FEATURE_UC_IN_WEBREGISTER_POPOVER]: false,
    [LRX_28094_COLLAPSIBLE_CASH_COUNTING]: false,
    [LRX_39407_CHEQUE_REFERENCE_WRITE]: false,
    [LRX_39407_CHEQUE_REFERENCE_READ]: false,
    [LRX_40761_ENABLE_QUANTITY_RECOGNIZED_WRITE_ON_TAKE_NOW]: false,
    [LRX_40761_ENABLE_QUANTITY_RECOGNIZED_WRITE_ON_FULFILLMENT]: false,
    [FEATURE_LRX_38368_MIGRATE_LEGACY_VERSION_REGISTER_SALES_WEBREGISTER]: false,
  },
  // Declare test environment overrides here
  [ENVS.TEST]: {
    promotions: true,
    [FEATURE_XMEN2565_RECEIPT_WEB_PRESENCE]: true,
    [FEATURE_UC_IN_WEBREGISTER_LINE_ITEM]: false,
    [FEATURE_UC_IN_WEBREGISTER_POPOVER]: false,
    [FEATURE_ALLOW_EDIT_UNFULFILLED_SALES]: true,
  },
  // Declare development environment overrides here
  [ENVS.DEVELOPMENT]: {
    cardholder_data_validation_webregister: false,
    cash_discounting: false,
    dark_mode: false,
    promotions_advanced: false,
    terminal_tipping: true,
    parked_sales_from_read_api: true,
    payment_type_controls: false,
    customer_groups: true,
    fulfill_from_another_outlet: true,
    has_qbo: false,
    pufs_ignore_accounting_integrations: false,
    react_workflows: true,
    custom_fields_on_receipt: true,
    payment_integration_origin_validation: true,
    create_new_sale_after_validating: true,
    validate_new_sale: true,
    enable_on_account_limit_enforcement: true,
    use_create_sale_endpoint: true,
    [LRX_39416_STALE_OFFLINE_SALE_REMEDIATION]: false,
    limit_product_images_in_webregister: true,
    [FEATURE_ROUND_TO_2DP_BEFORE_SENDING]: false,
    register_closure_reminder_A: false,
    register_closure_reminder_B: false,
    register_closure_reminder_lspay: true,
    auxiliary_lspay_active_pli: false,
    lspay_customer_facing_display_enabled: false,
    [FEATURE_STANDALONE_CUSTOMER_FACING_DISPLAY_ENABLED]: true,
    [FEATURE_LSPAY_ABLY_AUTHCALLBACK_ENABLED]: false,
    lspay_payment_links: false,
    lspay_pay_with_server_driven: false,
    lspay_refund_with_server_driven: false,
    lspay_referenced_refund_with_server_driven: false,
    lspay_server_driven_override: false,
    lspay_surcharge: false,
    lspay_cash_discounting: false,
    lspay_surcharge_xero_onaccount: false,
    lspay_surcharge_qbo_onaccount: false,
    lspay_pay_with_quick_pay_experiment: false,
    lspay_terminal_status_enabled: false,
    lspay_terminal_status_connection_logging_enabled: false,
    lspay_tipping_on_pre_tax_amount: false,
    raise_lspay_button_on_payment_screen_experiment: false,
    sales_person_attribution: true,
    enable_service_orders: true,
    register_online_only_customers_webregister: false,
    register_remove_local_customer_data_webregister: false,
    swiper_check_payment_type_available_jit: false,
    webregister_react_select_register: true,
    [FEATURE_ENABLE_CONTROL_ON_DISCOUNT]: false, // false for now, we don't want to change behavior for all devs yet
    increase_variant_limit: false,
    [FEATURE_ENABLE_REGISTER_ACCESS_CONTROL]: false,
    disable_translation: false,
    new_user_switching_in_app: false,
    enable_permission_park_sale_check: true,
    omni_gift_cards: false,
    omni_gift_cards_allow_short_codes: false,
    frontend_metrics: false,
    [CASH_COUNTING_FEATURE]: false,
    track_offline_sale_metadata: false,
    enable_customer_saved_cards: false,
    lspay_terminal_save_cards: false,
    lspay_show_repeat_card_detection: false,
    [FEATURE_ENABLE_INVOICING_PAYMENT_REQUESTS]: true,
    [FEATURE_ENABLE_INVOICING_NON_FULFILLMENT_PAYMENT_REQUESTS]: true,
    [FEATURE_ENABLE_INVOICING_QUOTE_PAYMENT_REQUESTS]: true,
    [FEATURE_ENABLE_INVOICING_PAYMENT_REQUEST_QUOTE_DELIVERY]: true,
    [FEATURE_ENABLE_INVOICING_PAYMENT_REQUEST_AU_COMPLIANCE]: true,
    [FEATURE_ENABLE_INVOICING_QUOTE_SERVICE]: true,
    [LRX_32023_MARK_ALL_ITEMS_FULFILLED]: false,
    [FEATURE_ENABLE_LRX_33701_STATE_VALIDATION]: false,
    inventory_special_orders: false,
    [FEATURE_SHOW_SPECIAL_ORDERS_IN_INVENTORY]: false,
    [FEATURE_NEW_TAX_EXEMPTION_ENABLED]: true,
    [FEATURE_BARCODE_FROM_SALE_ID]: true,
    [FEATURE_FULFILLMENT_TAKE_NOW_ITEM_PAYMENT_ENFORCEMENT]: true,
    [FEATURE_ALLOW_EDIT_UNFULFILLED_SALES]: true,
    [FEATURE_BARCODE_SCAN_ERROR_FIX]: true,
    [FEATURE_SSBO_ONBOARDING_COHORT]: false,
    [FEATURE_SSBO_GUIDED_TOUR]: false,
    [FEATURE_ON_ACCOUNT_PAYMENT_TYPE]: true,
    [FEATURE_ON_ACCOUNT_PAY_VIA_REGISTER]: true,
    [FEATURE_SURCHARGE_TRANSLATION]: false,
    [LRX_32242_FEATURE_FLAG_FIX_DUPLICATE_API_CALL_ON_SAVED_SALES]: false,
    [FEATURE_COMPLETE_PICKUP_AFTER_PAYMENT]: true,
    [FEATURE_REGISTER_BASEPRICE_AS_BESTPRICE]: true,
    [FEATURE_DISABLE_PAYMENT_BUTTONS_DURING_SALE_RECALCULATION]: true,
    [FEATURE_XMEN2565_RECEIPT_WEB_PRESENCE]: true,
    [FEATURE_FAILFAST_BULK_SOLD_BY]: true,
    [FEATURE_LSPAY_CNP_PAYMENTS]: true,
    [FEATURE_LSPAY_CP_CNP_SPLIT_ENTRY]: true,
    [FEATURE_UC_IN_WEBREGISTER_LINE_ITEM]: false,
    [LRX_41202_UC_IN_MARK_ALL_ITEM_FULFILLMENT]: false,
    [FEATURE_UC_IN_WEBREGISTER_POPOVER]: false,
    [LRX_28094_COLLAPSIBLE_CASH_COUNTING]: true,
    [LRX_39407_CHEQUE_REFERENCE_WRITE]: false,
    [LRX_39407_CHEQUE_REFERENCE_READ]: false,
    [LRX_40761_ENABLE_QUANTITY_RECOGNIZED_WRITE_ON_TAKE_NOW]: true,
    [LRX_40761_ENABLE_QUANTITY_RECOGNIZED_WRITE_ON_FULFILLMENT]: false,
    [FEATURE_LRX_38368_MIGRATE_LEGACY_VERSION_REGISTER_SALES_WEBREGISTER]: false,
  },
}
